import { HeaderKeys, HttpClientResponse, MimeType, QueryParameters, RequestHeaders } from './Definitions';
import { RequestExecutor } from './RequestExecutor';

export default class DevsiteRequestExecutor<T extends string> extends RequestExecutor<T> {
  protected execute(
    url: string,
    params: Partial<RequestInit>,
    headers?: RequestHeaders,
    queryParams?: QueryParameters
  ): Promise<HttpClientResponse> {
    return super.execute(
      url,
      params,
      {
        [HeaderKeys.CONTENT_TYPE]: MimeType.JSON,
        ...headers,
      },
      queryParams
    );
  }
}
